module.exports = __webpack_public_path__ + "img/icon-vr.da2af98f.svg";